import {createReducer, on} from '@ngrx/store';
import * as SynchronizationActions from './synchronization.actions';

export const synchronizationFeatureKey = 'synchronization';

export interface SynchronizationConfiguration {
  id: string,
  name: string,
  platform: string
}

export interface SynchronizationTaskHistory {
  id: string;
  result: 'FAILURE' | 'SUCCESS';
  taskConfigurationId: string;
  numberOfExternalEntities?: number;
  numberOfInternalEntities?: number;
  additionalInfo?: any;
  resultError?: string;
  performedBy?: string;
  performedAt: Date;
}

export interface State {
  configs: SynchronizationConfiguration[],
  taskHistory: { [configId: string]: SynchronizationTaskHistory[] }
}

export const initialState: State = {configs: [], taskHistory: {}};

export const reducer = createReducer(
  initialState,
  on(SynchronizationActions.loadSynchronizationsSuccess, (state, action) => ({...state, configs: action.configs})),
  on(SynchronizationActions.loadTaskHistorySuccess, (state, action) => ({
    ...state,
    taskHistory: {
      ...state.taskHistory,
      [action.configId]: action.histories
    }
  })),
);
